import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TranslateManager} from '../../../../common/translate/translate.manager';

@Component({
    selector: 'tfl-gentelella-modal-footer',
    template: `
        <div class="modal-footer">
            <ng-content></ng-content>
            <button *ngIf="showDefaultButtons" type="button" class="btn btn-default" (click)="dismiss()">
                {{dismissButtonLabel}}
            </button>
            <button *ngIf="showDefaultButtons" type="button" class="btn btn-primary" (click)="save()">
                {{saveButtonLabel}}
            </button>
        </div>
    `
})
export class GentelellaModalFooterComponent implements OnInit {

    @Input() showDefaultButtons: boolean = true;
    @Input() dismissButtonLabel?: string;
    @Input() saveButtonLabel?: string;
    @Output() dismissButtonAction?: EventEmitter<any>;
    @Output() saveButtonAction?: EventEmitter<any>;

    constructor(private _translateService: TranslateManager) {
    }

    ngOnInit(): void {
        if (this.showDefaultButtons) {
            this.dismissButtonLabel = this.dismissButtonLabel || this._translateService.getValue('MODAL.FOOTER.DISMISS');
            this.saveButtonLabel = this.saveButtonLabel || this._translateService.getValue('MODAL.FOOTER.SAVE');
            this.dismissButtonAction = new EventEmitter();
            this.saveButtonAction = new EventEmitter();
        }
    }

    dismiss(): void {
        if (this.showDefaultButtons) {
            this.dismissButtonAction.emit();
        }
    }

    save(): void {
        if (this.showDefaultButtons) {
            this.saveButtonAction.emit();
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/modal/modal-footer.component.ts